import { observer } from 'mobx-react-lite'
import { Scrollbar } from 'shared/ui'
import { useCompliancePageContext } from 'pages/settings/pages/compliance/context'
import { SummaryTollFreeItem } from './SummaryTollFreeItem/SummaryTollFreeItem'
import styles from './styles.module.scss'

export const SummaryTollFree = observer(() => {
  const { complianceLayerStore, tollFreeStepsStore, openDeleteModal } = useCompliancePageContext()
  const { organizationTollFree } = complianceLayerStore
  const { tollFreeNavigationStore } = tollFreeStepsStore

  if (!organizationTollFree?.items.length) return null

  return (
    <div className={styles.wrap}>
      <Scrollbar
        className={styles.scrollbar}
        viewClassName={styles.scrollbar__view}
        autoHeight
        autoHeightMin={0}
        autoHeightMax={'100%'}
        height={'100%'}
      >
        <div className={styles.scrollbar__content}>
          {organizationTollFree?.items.map((item) => {
            return (
              <SummaryTollFreeItem
                key={item.id}
                allStepsLength={tollFreeNavigationStore.allStepsLength}
                item={item}
                openDeleteModal={openDeleteModal}
              />
            )
          })}
        </div>
      </Scrollbar>
    </div>
  )
})
